module.exports = __webpack_public_path__ + "img/arrow_right_3.64b9cbc8.svg";